import { observable } from 'mobx'

const CloudGameClientStore = observable<CloudGameClientStore>({
  /** 云游戏单号 */
  gameCloudNo: '',
  /** 云游戏启动进度 */
  cloudGameStartProcess: 0,
  /** 云游戏错误弹窗信息 */
  cloudGameStartCrash: null,
  /** 云游戏业务提示框 */
  cloudErrorModalType: undefined,
  /** 云游戏Iframe状态 */
  cloudGameIframe: {
    status: 'normal',
    iframeSrc: '',
  },
  /** 云游戏页面是否加载完成 */
  cloudPageStatus: false,
  /** 退出云游戏弹窗显示 */
  visibleExitConfirmModal: false,
  /** 云游戏多人互动相关 */
  /** 是否多人模式 */
  multipleUserRole: 'none',
  multipleHasControl: 'none',
  multipleModalStatus: 'none',
  multiplayerInfo: null,
})

export default CloudGameClientStore

export const resetMultiplayerStore = () => {
  CloudGameClientStore.multipleUserRole = 'none'
  CloudGameClientStore.multipleHasControl = 'none'
  CloudGameClientStore.multipleModalStatus = 'none'
  CloudGameClientStore.multiplayerInfo = null
}
